var $body = $('body');
var myAnchors = [];
var myNavigation = [];
$(document).ready(function () {
    var landingPage = $('.video-banner');
    if (landingPage.length) {
        $('body').addClass("landing--page");
    } else {
        $('body').removeClass("landing--page");
    }
// Search Text Toggle
    $('.search-btn a').click(function () {
        $('.navigation').toggleClass('search-show');
    });
    $('.myVideo').attr('autoplay', 'true');
    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
    });
    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
        return false;
    });
    $('#menu li').each(function () {
        myAnchors.push($(this).attr('data-menuanchor'));
        myNavigation.push($(this).find('a').text());
    });
    if (win_width() > 1024) {
        $('.pointer-canvas').css('max-height', win_height());
        if (landingPage.length) {
            full_page();
        }

    } else {
        $('.video-banner, .myVideo,.pointer-canvas').css('min-height', win_height());
        $("#menu li > a").click(function (e) {
            $(this).parent().addClass('active');
            $(this).parent().siblings().removeClass('active');
            e.preventDefault();
            var target = ('#' + $(this).data('scroll'));
            var $target = $(target);
            $('html, body').animate({
                scrollTop: $target.offset().top - header_height()
            }, 800);
            $('body').removeClass('menu--open');
        });
    }
    $(".contact-form").submit(function (e) {
        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');
        var id = form.attr('id');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function (data)
            {
                var content = $(data).find('.contact-form');
                $(".contact-form").html(content);
            }
        });

    });
    $(".news-form").submit(function (e) {
        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');
        var id = form.attr('id');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function (data)
            {
                var content = $(data).find('.news-form');
                $(".news-form").html(content);
            }
        });
    });
});
$(window).resize(function () {
    if (win_width() > 1024) {
        $('.pointer-canvas').css('max-height', win_height());
    } else {
        $('.video-banner, .myVideo,.pointer-canvas').css('min-height', win_height());
    }
});
var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // Fixed Menu
    if (scroll >= 10) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }
//Scroll Down Script
    $('.scroll-down').bind('click', function (event) {
        var anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: ($(anchor.attr('href')).offset().top - header_height())
        }, 800);
        event.preventDefault();
    });
});
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}
function full_page() {
    var myFullpage = new fullpage('#fullpage', {
        anchors: myAnchors,
        navigation: true,
        navigationPosition: 'right',
        navigationTooltips: myNavigation,
        licenseKey: '',
        menu: '#menu'
    });
}


